import { DashboardCard } from "@/shared/ui/DashboardCard";
import { useTranslation } from "@/shared/providers/LanguageProvider";
import { abTests } from "../data";

const variantKeys = ["variantA", "variantB"] as const;

export function ABTestResults() {
  const { t } = useTranslation();

  return (
    <DashboardCard title={t.landing.abTestResults} className="col-span-full md:col-span-2">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        {abTests.map((test, i) => (
          <div
            key={variantKeys[i]}
            className={`rounded-2xl p-5 ${test.winner ? "bg-primary-soft ring-2 ring-primary" : "bg-card-muted"}`}
          >
            <div className="flex items-center justify-between">
              <p className="text-sm font-medium text-foreground">{t.landing.variants[variantKeys[i]]}</p>
              {test.winner && (
                <span className="rounded-full bg-primary px-2.5 py-0.5 text-xs font-semibold text-white">
                  {t.common.winner}
                </span>
              )}
            </div>
            <div className="mt-4 grid grid-cols-2 gap-4">
              <div>
                <p className="text-xs text-muted">{t.common.visitors}</p>
                <p className="text-lg font-bold text-foreground">{test.visitors.toLocaleString()}</p>
              </div>
              <div>
                <p className="text-xs text-muted">{t.common.conversions}</p>
                <p className="text-lg font-bold text-foreground">{test.conversions.toLocaleString()}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </DashboardCard>
  );
}
